import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {server} from '../app/conf'
@Injectable({
  providedIn: 'root'
})
export class ValidateUserService {

  constructor(
    private http:HttpClient
  ) { }
  validateCdeUser(passwordData){
    return this.http.post<any>(`${server}passwordvalidate/cdepasswordvalidate`,passwordData);
  }
}
